const VISIBLE_DIV_COUNT = 3;
const BUTTON_TEXT_MORE = "Více filtrů ...";
const BUTTON_TEXT_LESS = "Méně filtrů ...";
let enableCloseMobileFilter = false;
let enableCloseDesktopFilter = false;
let disableSliderWrapper = false;
let disablefilterSectionBoolean = false;



$(window).on('load', function () {
  if ($(window).width() <= 768) {
    $('nav#navigation ul.menu-level-2 li.has-third-level').each(function () {
      var $li = $(this);
      var $arrow = $li.find('.submenu-arrow');

      $arrow.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $li.toggleClass('open');
      });
    });
  }
});

$(document).ready(function(){
  if ($("body").hasClass("type-category")) {
    $('meta[property="og:image"]').each(function(){
      var content = $(this).attr("content");
      if(content && content.indexOf("https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/logos/logo-vyspimese-72dpi.png") !== -1){
        $(this).remove();
      }
    });

    $('meta#ogImageProducts').remove();
  }
});

(function() {
	var targetUrls = [
		'https://www.vyspimese.cz/kosik--nemazat/anatomicky-polstar-magniflex-magnicool-wave-2/',
		'https://www.vyspimese.cz/kosik--nemazat/zdravotni-matrace-drevocal-lima-polstar-zdarma-2/'
	];
    
	if (targetUrls.includes(window.location.href)) {
		document.body.classList.add('test');
	}
})();

